import React from "react";
import IconSvg from "./IconSvg";
import "./style.css";

const RoleListModal = ({ isOpen, onClose, roles }) => {
  if (!isOpen) return null;
  const handleOutsideClick = (e) => {
    if (e.target.className === "modal-overlay") {
      onClose();
    }
  };

  console.log("roless", roles);
  return (
    <div className="modal-overlay" onClick={handleOutsideClick}>
      <div className="absolute inset-0 bg-black opacity-50"></div>
      <div className="modal-content">
        <div className="modal-header ">
          <div className="flex justify-between items-center w-full">
            <h3 className="modal-header-title">All Role Fits</h3>
            <button onClick={onClose} className="modal-close-button">
              <IconSvg path="M6 18L18 6M6 6l12 12" className="h-6 w-6" />
            </button>
          </div>
        </div>
        <div className="modal-body">
          <div className="modal-note">
            <span>
              <span className="font-medium">Note:</span> Numbers in each column
              represent the <strong>count of students</strong> matched with each
              role at different readiness levels.
            </span>
          </div>
          <div className="modal-table-container">
            <table className="w-full table-fixed divide-y divide-gray-100">
              {/* sticky header helps when the modal/table scrolls */}
              <thead className="border-b sticky top-0 z-10">
                <tr>
                  <th
                    scope="col"
                    className="px-6 py-2 text-left text-xs font-medium uppercase tracking-wider "
                  >
                    Role Name
                  </th>

                  <th
                    scope="col"
                    className="px-6 py-1 text-right text-xs font-medium uppercase tracking-wider text-gray-500"
                  >
                    Students Count
                  </th>
                </tr>
              </thead>

              <tbody className="divide-y divide-gray-100">
                {roles && roles.length > 0 ? (
                  roles
                    .sort((a, b) => b.user_count - a.user_count)
                    .map((role) => (
                      <tr
                        key={role.id ?? role.role}
                        className="hover:bg-gray-50 transition-colors duration-150 border-b border-gray-200"
                      >
                        {/* left-aligned role cell */}
                        <td className="px-6 py-3 align-middle">
                          <div className="flex items-center gap-3">
                            <div className="truncate">
                              <div className="font-medium text-gray-900 truncate">
                                {role.role}
                              </div>
                            </div>
                          </div>
                        </td>

                        {/* right-aligned students cell */}
                        <td className="px-3 py-3 align-middle text-right">
                          <span
                            aria-hidden
                            className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold uppercase tracking-wide whitespace-nowrap ${
                              role.user_count >= 30
                                ? "bg-green-100 text-green-800"
                                : role.user_count >= 20
                                ? "bg-yellow-100 text-yellow-800"
                                : "bg-blue-100 text-blue-800"
                            }`}
                          >
                            {role.user_count}{" "}
                            {role.user_count === 1 ? "student" : "students"}
                          </span>
                        </td>
                      </tr>
                    ))
                ) : (
                  <tr>
                    <td
                      colSpan={2}
                      className="px-6 py-2 text-center text-sm text-gray-500"
                    >
                      No roles available.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
        <div className="modal-footer">
          <button onClick={onClose} className="modal-footer-button">
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default RoleListModal;
